import { Component } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Params, Router } from '@angular/router';
import { DataService } from 'src/app/services/data.service';
import { MessageService } from 'src/app/services/message.service';

@Component({
  selector: 'app-contacts-form',
  templateUrl: './contacts-form.component.html',
  styleUrls: ['./contacts-form.component.css'],
})
export class ContactsFormComponent {
  url: string = 'invoice';
  form!: FormGroup;

  data: Array<any> = [];
  
  id!: string;
  isLoading: boolean = false;

  constructor(
    private dataService: DataService,
    private fb: FormBuilder,
    private router: Router,
    private messageService: MessageService,
    private route: ActivatedRoute
  ) {
    this.initForm();
  }

  ngOnInit(): void {
    this.route.params.subscribe((params: Params) => {
      this.id = params['id'];

      if (this.id) {
        this.getData();
      }
    });
  }

  private initForm(): void {
    this.form = this.fb.group({
      contact_name: ['', [Validators.required]],
      company_name: ['', [Validators.required]],
      email: ['', [Validators.required]],
      phone: [''],
      address: ['', [Validators.required]],
      contact_person_id:[''],
      address_id:[''],
    });
  }

  isFieldInvalid(field: string) {
    return (
      this.form.get(field)?.invalid &&
      (this.form.get(field)?.dirty || this.form.get(field)?.touched)
    );
  }

  onSubmit(): void {
    if (this.id) {
      this.updateData();
    } else {
      this.createData();
    }
  }

  back() {
    this.router.navigateByUrl('billing/invoices/contacts');
  }

  getData(): void {
    this.isLoading = true;
    console.log('gen invoice getData', this.id);
    this.dataService.getData(`${this.url}/contacts/list/${this.id}`).subscribe((response) => {
      console.log('response getData', response);
      this.form.patchValue({
        contact_name: response.data.contact_name,
        company_name: response.data.company_name,
        email: response.data.email,
        phone: response.data.phone,
        address: response.data.billing_address.address,
        address_id : response.data.billing_address.address_id,
        contact_person_id: response.data.contact_persons[0].contact_person_id,
      });
      this.isLoading = false;
    });
  }

  createData() {
    console.log(' invoice createContact');
    this.isLoading = true;
    this.dataService
      .postData(`${this.url}/createContact`, this.form.value)
      .subscribe({
        next: (response: any) => {
          console.log('Respuesta del servidor createInvoice: ', response);
          if (response && response.rst === true) {
            this.form.reset();
            this.isLoading = false;
            this.router.navigateByUrl('/billing/invoices/contacts');
          } else {
          }
        },
        error: (error) => {
          console.error('Error al crear:', error);
          // this.messageService.add('Error al crear el : ' + (error.error?.msg || error.message), 'danger');
        },
      });
  }

  updateData(): void {
    console.log('gen invoice');
    this.isLoading = true;
    
    this.dataService
      .putData(`${this.url}/contacts/edit/${this.id}`, this.form.value)
      .subscribe({
        next: (response: any) => {
          console.log('Respuesta del servidor update invoice: ', response);
          if (response && response.rst === true) {
            this.form.reset();
            this.isLoading = false;
            this.router.navigateByUrl('/billing/invoices/contacts');
          } else {
          }
        },
        error: (error) => {
          console.error('Error al crear:', error);
          // this.messageService.add('Error al crear el : ' + (error.error?.msg || error.message), 'danger');
        },
      });
  }
}
